import { parseDataAttributes } from '../../utilities/utilities'
import { type SearchResultSortParameter, SortOrder } from '@haus-storefront-react/shared-types'

export type SortAttributes = {
  productListIdentifier?: string
  sortOptions: SortOption[]
}

export interface SortOption {
  labelKey: string
  value: SearchResultSortParameter
}

const ALL_SORT_OPTIONS: Array<{
  labelKey: string
  value: SearchResultSortParameter
  optionId: string
}> = [
  {
    labelKey: 'sort.popularityDesc',
    value: { popularity: SortOrder.Desc },
    optionId: 'popularity_desc',
  },
  { labelKey: 'sort.nameAsc', value: { name: SortOrder.Asc }, optionId: 'name_asc' },
  { labelKey: 'sort.nameDesc', value: { name: SortOrder.Desc }, optionId: 'name_desc' },
  { labelKey: 'sort.priceAscending', value: { price: SortOrder.Asc }, optionId: 'price_asc' },
  { labelKey: 'sort.priceDescending', value: { price: SortOrder.Desc }, optionId: 'price_desc' },
]

export function getSortAttributes(attrs: NamedNodeMap): SortAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  const productListIdentifier = base.productListIdentifier as string | undefined
  const enabledSortOptions = (base.enabledSortOptions as string[] | undefined) || [
    'popularity_desc',
    'name_asc',
    'name_desc',
    'price_asc',
    'price_desc',
  ]

  const sortOptions = ALL_SORT_OPTIONS.filter((option) =>
    enabledSortOptions.includes(option.optionId),
  ).map((option) => ({
    labelKey: option.labelKey,
    value: option.value,
  }))

  return {
    productListIdentifier,
    sortOptions,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): SortAttributes {
  return getSortAttributes(dataAttributes)
}
